/**
 * JWT 토큰에서 특정 키 값을 가져오는 함수
 * @param key 가져오려는 필드명 (예: "rmaWriteYn")
 * @returns 해당 필드의 값 (기본적으로 string | null, 불리언 변환 가능)
 */
export const getJwtPayloadValue = (key: string): boolean | undefined => {
    try {
        const accessToken = localStorage.getItem("mdstech_accessToken");
        if (!accessToken) return false;

        const base64Data = accessToken.split(".")[1];
        if (!base64Data) return false;

        const base64 = base64Data.replace(/-/g, "+").replace(/_/g, "/");
        const jsonPayload = JSON.parse(atob(base64));

        if (jsonPayload.authority) {
            const authority = JSON.parse(jsonPayload.authority);
            return authority[key] === "Y" ? true : false;
        }
    } catch (error) {
        console.error("JWT 디코딩 오류:", error);
        return false;
    }
};